/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Shared_Banner_TitleInputs */



/**
* | output |
* | --- |
* | "Shared Artifact" |
*
* @param {Artifact_Shared_Banner_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_shared_banner_title = /** @type {((inputs?: Artifact_Shared_Banner_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Shared_Banner_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geteiltes Artefakt")
	return /** @type {LocalizedString} */ ("Shared Artifact")
});